import React from 'react';

const btnTypes = {
  primary: 'bg-sky-500 sm:hover:bg-sky-600 dark:bg-sky-600 dark:sm:hover:bg-sky-500',
  secondary: 'bg-fuchsia-500 sm:hover:bg-fuchsia-600 dark:bg-fuchsia-600 dark:sm:hover:bg-fuchsia-500',
  danger: 'bg-rose-500 sm:hover:bg-rose-600 dark:bg-rose-600 dark:sm:hover:bg-rose-500',
  success: 'bg-emerald-500 sm:hover:bg-emerald-600 dark:bg-emerald-600 dark:sm:hover:bg-emerald-500',
  special: 'bg-amber-500 sm:hover:bg-amber-600 dark:bg-amber-600 dark:sm:hover:bg-amber-500',
  warning: 'bg-orange-500 sm:hover:bg-orange-600 dark:bg-orange-600 dark:sm:hover:bg-orange-500',
  disabled: 'bg-black cursor-not-allowed opacity-50',
};

const Button = ({ onClick, icon, text, type, disabled, animation, titleContent }) => {
  const btnType = disabled ? btnTypes['disabled'] : btnTypes[type] || btnTypes['primary'];

  return (
    <button
      className={`text-white p-2 font-bold rounded cursot-pointer transition
                    ${btnType} ${!disabled && animation}
                    ${text === "Log Out" && 'sm:ml-auto'}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={titleContent}
    >
      <div className="flex flex-row gap-2 justify-center items-center">
        {icon ? <span>{icon}</span> : null}
        {text ? <span>{text}</span> : null}
      </div>
    </button>
  );
};

export default Button;
